export type CountryData = {
  dialingCode: string
  flag: string
  name: string
};

export const countryData: CountryData[] = [
  { dialingCode: "+49", flag: "🇩🇪", name: "Allemagne" },
  { dialingCode: "+32", flag: "🇧🇪", name: "Belgique" },
  { dialingCode: "+1", flag: "🇨🇦", name: "Canada" },
  { dialingCode: "+34", flag: "🇪🇸", name: "Espagne" },
  { dialingCode: "+33", flag: "🇫🇷", name: "France" },
  { dialingCode: "+590", flag: "🇬🇵", name: "Guadeloupe" },
  { dialingCode: "+594", flag: "🇬🇫", name: "Guyane française" },
  { dialingCode: "+39", flag: "🇮🇹", name: "Italie" },
  { dialingCode: "+352", flag: "🇱🇺", name: "Luxembourg" },
  { dialingCode: "+596", flag: "🇲🇶", name: "Martinique" },
  { dialingCode: "+687", flag: "🇳🇨", name: "Nouvelle-Calédonie" },
  { dialingCode: "+31", flag: "🇳🇱", name: "Pays-Bas" },
  { dialingCode: "+689", flag: "🇵🇫", name: "Polynésie française" },
  { dialingCode: "+351", flag: "🇵🇹", name: "Portugal" },
  { dialingCode: "+262", flag: "🇷🇪", name: "Réunion" },
  { dialingCode: "+44", flag: "🇬🇧", name: "Royaume-Uni" },
  { dialingCode: "+508", flag: "🇵🇲", name: "Saint-Pierre-et-Miquelon" },
  { dialingCode: "+41", flag: "🇨🇭", name: "Suisse" },
  { dialingCode: "+681", flag: "🇼🇫", name: "Wallis-et-Futuna" },
];
